import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, map, of } from 'rxjs';
import { SVDSInfo } from 'src/app/shared/models/case-creation/vehicle.model';
import { CheckVin } from 'src/app/shared/models/check-vin.model';

import { DealerStore } from '../../stores/dealer.store';
import { CaseCreationStore } from '../../stores/v2/case-creation.store';
import { VehicleService } from '../vehicle.service';

@Injectable()
export class SelectionVinsService {
  private readonly caseCreationStore = inject(CaseCreationStore);
  private readonly dealerStore = inject(DealerStore);
  private readonly vehicleService = inject(VehicleService);

  loadSelectedVinsVehicleInformation(destroy: DestroyRef): void {
    const dealer = this.dealerStore.selectedDealer();
    if (!dealer) {
      return;
    }

    const vins = [...this.caseCreationStore.getInitialSelectedVins()];
    this.vehicleService
      .getVehicleInfo(vins, dealer.dealerVPNr, dealer.bpId)
      .pipe(
        takeUntilDestroyed(destroy),
        catchError(() => {
          return of([]);
        }),
        map((checkVins) => checkVins.map((vehicle) => {
         return this.mapVehicleInformation(vehicle)
        }))
      )
      .subscribe((vehicles) => this.caseCreationStore.setSvdsInformation(vehicles));
  }

  private mapVehicleInformation(vehicle: CheckVin): SVDSInfo {
    const vehicleInformation = vehicle.vehicle;
    return {
      vin: vehicleInformation.vin,
      iStep: vehicleInformation.iStep,
      shipToID: vehicleInformation.shipToID,
      model: vehicleInformation.modelName,
      vehicleType: vehicleInformation.driveTrain,
      series: vehicleInformation.modelRange,
      color: vehicleInformation.colourCode,
      action: vehicle.action,
      checkVinStatus: vehicle.checkVinStatus,
      pureCode: vehicle.pureCode,
    };
  }
}
